module.exports = __webpack_public_path__ + "img/产品优势_多源数据集成.38f3de9c.png";